import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { COMPLIANCE_STAFF_ROLES } from '@workspace/utils'
import { RestrictivePracticesRegisterPage } from '@/features/compliance-registers/restrictive-practices'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'

const searchSchema = z.object({
  practice: z.string().optional(),
  use: z.string().optional(),
  client: z.string().optional(),
  status: z.string().optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
})

/**
 * Mirrors the API's `requireComplianceStaffRead`
 * (apps/api/src/routes/organizations/compliance-hub.route.ts:22) — no
 * `health_carer` / `supported_employee` — so a support worker is bounced to
 * /403 up front instead of landing on a page whose data all 403s. Workers
 * reach restrictive practices through the shift briefing and the
 * record-a-use screen, not through the register.
 * Role-list reconciliation: shared via `@workspace/utils` — see hub.tsx's
 * comment for why this stopped being six independent hand-typed copies.
 */
export const Route = createFileRoute('/_authenticated/_organization/compliance/restrictive-practices/')({
  beforeLoad: async () => {
    await requireRoles([...COMPLIANCE_STAFF_ROLES])
    await requireActiveSubscription()
  },
  validateSearch: searchSchema,
  component: RestrictivePracticesRegisterPage,
})
